import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../tools/store";

const initialState: {
  currentPage: number;
  selectedItem: any;
} = {
  currentPage: 1,
  selectedItem: {},
};
export const NonPersistGlobalReducerName = "non_persist_global";

export const NonPersistGlobalSlice = createSlice({
  name: NonPersistGlobalReducerName,
  initialState,
  reducers: {
    setCurrentPage(state, action: PayloadAction<number>) {
      state.currentPage = action.payload;
    },
    setSelected(state, action: PayloadAction<any>) {
      state.selectedItem = action.payload;
    },
  },
});

export const { setCurrentPage, setSelected } = NonPersistGlobalSlice.actions;

export const getCurrentPage = (state: RootState) =>
  state.non_persist_global.currentPage;

export const getSelectedItem = (state: RootState) =>
  state.non_persist_global.selectedItem;

export default NonPersistGlobalSlice.reducer;
